import { Button, CircularProgress, Grid, Stack, styled, TextField } from "@mui/material";
import React from "react";
import { PRIMARY_LIGHT_BLUE, WHITE } from "../../colors";
import SendIcon from "@mui/icons-material/Send";
import FeedsService from "../../services/feedService";

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 52,
  maxWidth: 280,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));
const SendMessage = ({ handleChange, loading, message, onSubmit }) => {
 
  return (
    <Grid container>
      <Grid xs={10}>
        <CustomTextField
          onChange={(e) => handleChange(e.target.value)}
          value={message}
          placeholder="Type message here"
          onKeyPress={(ev) => {
            // console.log(`Pressed keyCode ${ev.key}`);
            if (ev.key === 'Enter') {
              onSubmit();
              ev.preventDefault();
            }
          }}
        />
      </Grid>
      <Grid xs={2}>
        <CustomButton type="submit" onClick={onSubmit} variant="contained" endIcon={<SendIcon />} 
        onKeyPress={(ev) => {
          console.log(`Pressed keyCode ${ev.key}`);
          if (ev.key === 'Enter') {
            // Do code here
            ev.preventDefault();
          }
        }}
        >
          {loading ? <CircularProgress size={15} /> : "Send"}{" "}
        </CustomButton>
      </Grid>
    </Grid>
  );
};

export default SendMessage;
